import axios from 'axios';
import { getAppCheckToken } from "./appCheck";

const TIMEOUT = 5; //minutes
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 1000 * 60 * TIMEOUT,
  headers: {
    "x-app": process.env.REACT_APP_API_TOKEN,
    "Content-Type": "application/json",
    Accept: 'application/json',
  }
});

export const getHomeContentAPI = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const token = await getAppCheckToken();
      const response = await instance.get(`/web/home`, {
        headers: {
          "X-Firebase-AppCheck": token,
        }
      });
      if (response?.data?.status) {
        resolve(response?.data?.data);
      } else {
        reject(response?.data?.error);
      }
    } catch (error) {
      console.error("[getHomeContentAPI] error", error);
      reject(error);
    }
  })
}